var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "warp" },
    [
      _c(
        "el-form",
        { key: _vm.keyInvoice, attrs: { "label-width": "auto" } },
        [
          _c(
            "el-row",
            { attrs: { gutter: 20 } },
            [
              _c(
                "el-descriptions",
                { attrs: { colon: false, column: 3, direction: "vertical" } },
                [
                  _c(
                    "el-descriptions-item",
                    { attrs: { label: _vm.$t("GlobalSetObj.signedPhoto") } },
                    [
                      _c("sensitive-images", {
                        attrs: {
                          "field-name": "signedNamePhoto",
                          "encrypted-value":
                            _vm.tableInfomation.signedNamePhoto,
                          label: _vm.$t("GlobalSetObj.signedPhoto"),
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-descriptions-item",
                    {
                      attrs: {
                        label: _vm.$t("GlobalSetObj.signedNamePhoto"),
                        span: 2,
                      },
                    },
                    [
                      _c("sensitive-images", {
                        attrs: {
                          "field-name": "signedPhoto",
                          "encrypted-value": _vm.tableInfomation.signedPhoto,
                          label: _vm.$t("GlobalSetObj.signedNamePhoto"),
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-descriptions-item",
                    { attrs: { label: _vm.$t("GlobalSetObj.TypeRecipient") } },
                    [
                      _c("div", [
                        _vm._v(_vm._s(_vm.tableInfomation.signTypeName)),
                      ]),
                    ]
                  ),
                  _c(
                    "el-descriptions-item",
                    { attrs: { label: _vm.$t("GlobalSetObj.signRelation") } },
                    [
                      _c("div", [
                        _vm._v(
                          _vm._s(_vm.tableInfomation.notMyselfTypeStr || "--")
                        ),
                      ]),
                    ]
                  ),
                  _c(
                    "el-descriptions-item",
                    { attrs: { label: _vm.$t("GlobalSetObj.SignerName") } },
                    [
                      _c("encryption-field", {
                        attrs: {
                          "field-name": "deliverySigner",
                          "encrypted-value": _vm.tableInfomation.deliverySigner,
                          label: "deliverySigner",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-descriptions-item",
                    { attrs: { label: _vm.$t("GlobalSetObj.RecipientDOC") } },
                    [
                      _c("encryption-field", {
                        attrs: {
                          "field-name": "receiverDocumentNumber",
                          "encrypted-value":
                            _vm.tableInfomation.receiverDocumentNumber,
                          label: "receiverDocumentNumber",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-descriptions-item",
                    {
                      attrs: {
                        label: _vm.$t("GlobalSetObj.SigningTime"),
                        span: 3,
                      },
                    },
                    [
                      _c("div", [
                        _vm._v(
                          _vm._s(_vm.tableInfomation.deliveredTime || "--")
                        ),
                      ]),
                    ]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }